import * as dd from 'dingtalk-jsapi';
// 判断当前是否在钉钉容器内
function isDingTalk() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('dingtalk') > -1 || dd.env.platform !== 'notInDingTalk'
}

/**
 * 存储数据（兼容钉钉 + 浏览器）
 */
export function setStorageSync(key, data) {
  try {
    const value = typeof data === 'string' ? data : JSON.stringify(data)

    // if (isDingTalk()) {
    //   // 钉钉环境
    //   dd.setStorageSync({ key, value })
    // } else {
      // 普通浏览器环境
      localStorage.setItem(key, value)
   // }
    return true
  } catch (err) {
    console.error('setStorageSync 失败：', err)
    return false
  }
}

/**
 * 获取数据（兼容钉钉 + 浏览器）
 */
export function getStorageSync(key, defaultValue = null) {
  try {
    let value = null

    // if (isDingTalk()) {
    //   // 钉钉环境
    //   const res = dd.getStorageSync({ key })
    //   value = res ? res.value : null
    // } else {
      // 普通浏览器环境
      value = localStorage.getItem(key)
   // }

    if (value === null || value === undefined || value === '') {
      return defaultValue
    }

    // 自动解析 JSON
    try {
      return JSON.parse(value)
    } catch {
      return value
    }
  } catch (err) {
    console.error('getStorageSync 失败：', err)
    return defaultValue
  }
}

/**
 * 删除单个数据
 */
export function removeStorageSync(key) {
  try {
    // if (isDingTalk()) {
    //   dd.removeStorageSync({ key })
    // } else {
      localStorage.removeItem(key)
   // }
    return true
  } catch (err) {
    console.error('removeStorageSync 失败：', err)
    return false
  }
}

/**
 * 清空所有缓存
 */
export function clearStorageSync() {
  try {
    if (isDingTalk()) {
      dd.clearStorageSync()
    } else {
      localStorage.clear()
    }
    return true
  } catch (err) {
    console.error('clearStorageSync 失败：', err)
    return false
  }
}

export default {
  setStorageSync,
  getStorageSync,
  removeStorageSync,
  clearStorageSync,
  isDingTalk
}

// 存
//this.$storage.setStorageSync('token', '123456')
//this.$storage.setStorageSync('userInfo', { name: '张三' })

// 取
//let token = this.$storage.getStorageSync('token')
//let user = this.$storage.getStorageSync('userInfo')

// 删除
//this.$storage.removeStorageSync('token')

// 清空
//this.$storage.clearStorageSync()
